


















































































































import Vue, { PropType } from "vue";
import InfiniteLoading from "vue-infinite-loading";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import PopoverSelectBox from "@/components/Atoms/Forms/PopoverSelectBox/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import CompetitorCard from "../../Molecules/CompetitorCard/index.vue";
import debounce from "lodash/debounce";
import { CombinedVueInstance } from "vue/types/vue";
import { KEYCODE } from "@/constants/event";
import { Data, Methods, Computed, Props } from "./types";
import { CompetitorsQuerySort } from "@/api/types";
import { numberWithCommas } from "@/helpers/format-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompetitorFloatingView",
  components: {
    Overlay,
    FloatingView,
    PopoverSelectBox,
    Heading,
    Body,
    SearchTextField,
    CompetitorCard,
    InfiniteLoading
  },
  props: {
    companiesTotal: {
      type: Number as PropType<Application.CompaniesTotal>,
      required: true
    },
    companies: {
      type: Array as PropType<Application.Company[]>,
      required: true,
      default: () => []
    },
    competitors: {
      type: Array as PropType<Application.Competitor[]>,
      required: true,
      default: () => []
    },
    loadingCompaniesIds: {
      type: Array as PropType<Props["loadingCompaniesIds"]>,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      value: "",
      competitorsQuery: {
        business_category_id: "",
        sort: CompetitorsQuerySort.Likes
      },
      businessCategoryType: [
        {
          label: "指定なし",
          value: ""
        },
        {
          label: "コンサル・シンクタンク",
          value: "1"
        },
        {
          label: "金融",
          value: "2"
        },
        {
          label: "メーカー",
          value: "3"
        },
        {
          label: "商社",
          value: "4"
        },
        {
          label: "IT・通信",
          value: "5"
        },
        {
          label: "広告・マスコミ",
          value: "6"
        },
        {
          label: "人材・教育",
          value: "7"
        },
        {
          label: "インフラ・交通",
          value: "8"
        },
        {
          label: "不動産・建設",
          value: "9"
        },
        {
          label: "旅行・観光",
          value: "10"
        },
        {
          label: "ブライダル・美容・くらし",
          value: "11"
        },
        {
          label: "医療・福祉",
          value: "12"
        },
        {
          label: "小売・流通",
          value: "13"
        },
        {
          label: "公務員・団体職員",
          value: "14"
        },
        {
          label: "その他",
          value: "15"
        }
      ],
      sortType: [
        {
          label: "人気順",
          value: CompetitorsQuerySort.Likes
        },
        {
          label: "クチコミ評価順",
          value: CompetitorsQuerySort.Reviews
        },
        {
          label: "自社とよく比較される順",
          value: CompetitorsQuerySort.LikesDup
        },
        {
          label: "自社と内定者が被りやすい順",
          value: CompetitorsQuerySort.Prehire
        }
      ]
    };
  },
  computed: {
    companiesTotalLocale() {
      return numberWithCommas(this.companiesTotal);
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handlePressEsc);
  },
  methods: {
    handleClear() {
      this.value = "";
      this.$emit("initCompanies");
      this.infiniteClear();
    },
    handleClose() {
      this.value = "";
      this.$emit("initCompanies");
      this.$emit("closeCompetitorFloatingView");
    },
    handleInput: debounce(function(
      this: CombinedVueInstance<Vue, Data, Methods, Computed, Props>
    ) {
      this.value = this.value.trim();
      this.$emit("initCompanies");
      this.infiniteClear();
    },
    500),
    businessCategoryQueryChange() {
      this.$emit("initCompanies");
      this.infiniteClear();
    },
    sortQueryChange() {
      this.$emit("initCompanies");
      this.infiniteClear();
    },
    isCompanyLoading(company) {
      return this.loadingCompaniesIds.some(
        companieId => companieId === company.id
      );
    },
    isCompanySelected(company) {
      if (!this.competitors) {
        return false;
      }
      return this.competitors.some(competitor => {
        return competitor.company.id === company.id;
      });
    },
    handleAddCompetitor(company) {
      this.$emit("addCompetitor", company);
    },
    handleDeleteCompetitor(company) {
      this.$emit("deleteCompetitor", company);
    },
    handlePressEsc(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.handleClose();
    },
    infiniteClear() {
      const infiniteLoading = this.$refs.infiniteLoading as
        | InfiniteLoading
        | undefined;
      infiniteLoading?.stateChanger.reset();
    },
    infiniteHandler($state) {
      this.$nextTick(async () => {
        if (!this.$store.state.domains.user.partnerUser) {
          return;
        }
        this.$store.commit("pages/plan/competitorSearchParams", {
          params: {
            company_name: this.value,
            limit: 20,
            offset: this.$store.state.pages.plan.companies.length,
            business_category_id: this.competitorsQuery.business_category_id,
            sort: this.competitorsQuery.sort
          }
        });

        await this.$store.dispatch("pages/plan/getCompanyList", {
          plan_id: Number(this.$route.params["planId"]),
          company_name: this.value,
          business_category_id: this.competitorsQuery.business_category_id,
          sort: this.competitorsQuery.sort
        });

        if (this.companies.length < this.companiesTotal) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }
});
